import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMe } from './api/queries.js';
import Layout from './components/Layout.js';
import Login from './pages/Login.js';
import Landing from './pages/Landing.js';
import Feed from './pages/Feed.js';
import Saved from './pages/Saved.js';
import Sources from './pages/Sources.js';
import Settings from './pages/Settings.js';
import ArticleDetail from './pages/ArticleDetail.js';
import Search from './pages/Search.js';
import Admin from './pages/Admin.js';
import AdminUser from './pages/AdminUser.js';

export default function App() {
  const { t } = useTranslation();
  const me = useMe();
  const location = useLocation();

  // isPending (not isLoading): on the very first render the fetch has not started yet,
  // so isLoading is false and a deep link (/settings, /c/:id) bounced via /login to /
  if (me.isPending) {
    return (
      <div className="flex min-h-screen items-center justify-center text-neutral-500">
        {t('common.loading')}
      </div>
    );
  }

  const loggedIn = !!me.data;

  // signed-out: landing on "/", the form on "/login" (kept for deep links + Android TWA),
  // anything else bounces to the form
  if (!loggedIn) {
    return (
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="*"
          element={<Navigate to="/login" replace state={{ from: location.pathname + location.search }} />}
        />
      </Routes>
    );
  }
  if (location.pathname === '/login') {
    return <Navigate to="/" replace />;
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Feed />} />
        <Route path="/saved" element={<Saved />} />
        <Route path="/sources" element={<Sources />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/search" element={<Search />} />
        <Route path="/c/:id" element={<ArticleDetail />} />
        <Route path="/admin" element={me.data?.user.isAdmin ? <Admin /> : <Navigate to="/" replace />} />
        <Route path="/admin/users/:id" element={me.data?.user.isAdmin ? <AdminUser /> : <Navigate to="/" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
